<div>
  <div class="sticky !bg-[#fff] top-0 !p-0">
    <div
      class="flex justify-between items-center sticky top-0 !bg-[#dee2e6] p-4 !pl-[31px] !pr-[40px]"
    >
      <div class="flex justify-start items-center gap-8 !bg-[#dee2e6]">
        <h3 class="project-plan">Project Plan</h3>
        <span
          class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
          >Cost Estimation</span
        >
      </div>
      <!-- Close Icon -->
      <div
        style="position: absolute; top: 10px; right: 36px; z-index: 50"
        (click)="closeDialog()"
      >
        <img
          src="assets/icons/cross-icon.svg"
          alt="cross icon"
          class="cursor-pointer !fixed"
        />
      </div>
    </div>
    <div class="flex justify-end">
      <app-progress-bar
        [progress]="stage2Progress"
        [sectionId]="'section2'"
        [selectedSection]="selectedSection"
        [sectionName]="'Project Plan'"
      >
      </app-progress-bar>
    </div>
  </div>
  <div class="flex justify-center p-6 !px-[40px]">
    <div class="main-section">
      <div class="table-scroll">
        <div class="">
          <table class="w-full table-auto table-striped">
            <thead
              style="
                width: 100%;
                background-color: #dee2e6;
                color: black;
                height: 49px;
              "
            >
              <tr class="sticky !z-20 top-0">
                <th class="w-1/2 !text-left">Work Packages Standard Items</th>
                <th class="w-1/2 !text-left">Cost Estimate</th>
              </tr>
            </thead>
            <tbody *ngFor="let work_package of items; let i = index">
              <ng-container *ngIf="work_package.children.length > 0">
                <tr *ngFor="let child of work_package.children">
                  <td class="!text-left">{{ child.name }}</td>

                  <td class="flex flex-col justify-end items-start">
                    <input
                      (ngModelChange)="onChildCostEstimateChange($event, child)"
                      class="currency-input"
                      [(ngModel)]="child.cost_estimate"
                      placeholder="Enter cost estimate"
                      currencyMask
                      [options]="currencyOptions"
                    />
                    <span class="w-full text-[12px] mt-[8px]">
                      {{ numberToWords(child?.cost_estimate) | titlecase }}
                    </span>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="work_package.children.length === 0">
                <tr>
                  <td class="!text-left">{{ work_package.name }}</td>

                  <td class="flex flex-col justify-end items-start">
                    <input
                      (ngModelChange)="onCostEstimateChange($event)"
                      maxlength="12"
                      class="currency-input"
                      [(ngModel)]="work_package.cost_estimate"
                      placeholder="Enter cost estimate"
                      currencyMask
                      [options]="currencyOptions"
                    />
                    <span class="w-full text-[12px] mt-[8px]">
                      {{
                        numberToWords(work_package?.cost_estimate) | titlecase
                      }}
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="w-[100%] flex justify-end items-center mt-[20px] sticky">
    <button
      (click)="handleBack()"
      type="button"
      class="save-btn !mr-[10px] !bg-[#fff]"
    >
      Back
    </button>

    <button
      class="save-btn shadow-[0px_4px_4px_rgba(0,0,0,0.25)] !font-medium"
      type="button"
      (click)="navigateWorkDistribution('save')"
    >
      <ng-container *ngIf="isLoadingSave; else normalTextSave">
        <div class="spinner"></div>
      </ng-container>
      <ng-template #normalTextSave>Save</ng-template>
    </button>
    <button
      class="next-btn"
      type="button"
      (click)="navigateWorkDistribution('next')"
      [ngClass]="{ 'loading-btn': isLoadingNext }"
    >
      <ng-container *ngIf="isLoadingNext; else normalTextNext">
        <div class="spinner"></div>
      </ng-container>
      <ng-template #normalTextNext>Next</ng-template>
    </button>
  </div>
</div>
